import hasActiveContracts from '@/mixins/hasActiveContracts'

import { ManagerGQL } from '@/graphql/queries'

export default {
  mixins: [hasActiveContracts],

  apollo: {
    contractList: {
      query: ManagerGQL,
      update: data => data.merchant.manager.partnerContractList,
      skip () { return !this.hasActiveContracts }
    }
  },

  computed: {
    contractIds () {
      if (!this.contractList) {
        return []
      }

      return this.contractList.map(c => c.id)
    }
  }
}
